import GroupsCard from "./GroupsCard"

export default  GroupsCard;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/Groups/GroupsCard/index.js